import React from 'react';
import { ReactComponent as ReturnsIcon } from '../../assets/images/icons/returns.svg';
import { ReactComponent as ShippingIcon } from '../../assets/images/icons/shipping.svg';
import styles from './CartSummary.module.scss';
import { useTranslation } from 'react-i18next';
import useFreeShippingDisplay from '../../hooks/useFreeShippingDisplay';
import useCartHasFreeTrialBundle from '../../hooks/useCartHasFreeTrialBundle';
import useCartItemV2Enabled from '../../hooks/useCartItemV2Enabled';

export default function CartValueProps() {
  const { t } = useTranslation();
  const { isFreeShipping, shippingPrice } = useFreeShippingDisplay();
  const hasFreeTrialBundle = useCartHasFreeTrialBundle();
  const isCanadaFreeTrial = useCartItemV2Enabled();

  const shippingText = isFreeShipping
    ? t('free_ground_shipping_with_period')
    : t('ground_shipping_price_with_period', { price: shippingPrice });

  if (isCanadaFreeTrial) {
    return (
      <div className={styles.cartValuePropsContainer}>
        <div className={styles.cartValuePropsCelledSection}>
          <div className={styles.cartValueProp}>
            <div className={styles.cartValuePropIcon}>
              <ReturnsIcon />
            </div>
            <div className={styles.cartValuePropText}>
              <div>{t('trust_badges.risk_free')}</div>
            </div>
          </div>
          <div className={styles.cartValueProp}>
            <div className={styles.cartValuePropIcon}>
              <span>{'🇨🇦'}</span>
            </div>
            <div className={styles.cartValuePropText}>
              <div>{t('trust_badges.now_available_canada')}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cartValuePropsContainer}>
      <div className={styles.cartValuePropsCelledSection}>
        <div className={styles.cartValueProp}>
          <div className={styles.cartValuePropIcon}>
            <ShippingIcon />
          </div>
          <div className={styles.cartValuePropText}>
            <div>{shippingText}</div>
            <div>{t('one_to_two_day_available_at_checkout')}</div>
          </div>
        </div>
        <div className={styles.cartValueProp}>
          <div className={styles.cartValuePropIcon}>
            <ReturnsIcon />
          </div>
          <div className={styles.cartValuePropText}>
            <div>{hasFreeTrialBundle ? t('free_trial_benefit_1') : t('thirty_day_risk_free_hyphenated')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
